import React, { useEffect } from "react";
import { ForgetPasswordFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Inputs, Buttons } from "components";

const ForgetPasswordForm = ({ initialEmail, onSignUp, onSubmit }) => {
  const schema = yup.object().shape({
    username: yup.string().required("*Required"),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (initialEmail) {
      reset({ username: initialEmail });
    }
  }, [initialEmail, reset]);

  const { t } = useTranslation(["common", "form"]);

  return (
    <ForgetPasswordFormStyled>
      <div className="login_header">
        {t("Reset your password", { ns: "common" })}
      </div>
      <div className="sub_title_form">
        {t(
          "Enter your registered YAMAHA email. We’ll send a password reset link to your inbox so you can get back to your account.",
          { ns: "form" },
        )}
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                placeholder={t("Enter your Email", { ns: "form" })}
                errors={errors.username?.message}
              />
            )}
            name="username"
            defaultValue={initialEmail || ""}
          />
        </div>
        <div className="btn_wrap">
          <Buttons.BgStandard
            type="submit"
            label={t("Continue", { ns: "common" })}
          />
        </div>
        <button
          type="button"
          className="btn_forget_passwoed"
          onClick={onSignUp}
        >
          {t("Don't have an account yet?", { ns: "form" })}
        </button>
      </form>
    </ForgetPasswordFormStyled>
  );
};

ForgetPasswordForm.propTypes = {};
export default ForgetPasswordForm;
